const topics = [
  { label: '最新爆料', heat: '9.8w', icon: 'ri-fire-line', accent: true },
  { label: '塌房实锤', heat: '8.5w', icon: 'ri-alert-line', accent: true },
  { label: '大号扒皮', heat: '7.2w', icon: 'ri-search-eye-line', accent: false },
  { label: '情感纠纷', heat: '6.8w', icon: 'ri-heart-pulse-line', accent: false },
  { label: '税务风波', heat: '5.4w', icon: 'ri-money-cny-box-line', accent: false },
  { label: '假货翻车', heat: '5.1w', icon: 'ri-forbid-line', accent: false },
  { label: '人设崩塌', heat: '4.7w', icon: 'ri-emotion-sad-line', accent: false },
  { label: '私生活混乱', heat: '4.3w', icon: 'ri-eye-off-line', accent: false },
  { label: '合同纠纷', heat: '3.9w', icon: 'ri-file-list-3-line', accent: false },
  { label: '直播事故', heat: '3.6w', icon: 'ri-live-line', accent: false },
  { label: '法律追责', heat: '3.2w', icon: 'ri-scales-line', accent: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">话题热榜</h2>
            <p className="mt-2 text-sm text-foreground-500">当前最火的网红黑料话题标签，点击探索你关心的瓜</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <div
                key={topic.label}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 hover:scale-105 ${
                  topic.accent
                    ? 'bg-primary-500/15 border border-primary-500/30 text-primary-400'
                    : 'bg-background-200/70 border border-background-300/40 text-foreground-600 hover:border-primary-500/30 hover:text-primary-400'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${topic.icon} text-sm`}></i>
                </span>
                <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}